import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getUserByIdApi,
  getUserBySessionId,
  getUsersBySessionId,
} from "../../Modules/Services/User";
import {
  joinSessionApi,
  createSessionApi,
  getSessionByIdApi,
} from "../../Modules/Services/session";
import { toast } from "react-toastify";
import { updateEmotionStatusApi } from "../../Modules/Services/emotion";
import { stopLoading } from "../slices/sessionSlice";


export const createSession = createAsyncThunk(
  "session/createSession",
  async (values, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await createSessionApi(values);
      setTimeout(() => {
        dispatch(stopLoading())
      }, 1200)
      return data;
    } catch (err) {
      if (err.code === "ERR_NETWORK");
      toast.error(
        err.message || "Network error. Please check your internet connection."
      );
      return rejectWithValue(err.message);
    }
  }
);

export const joinSession = createAsyncThunk(
  "session/joinSessionBySessionId",
  async ({ session_ID, ...rest }, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await joinSessionApi(rest);
      setTimeout(() => {
        dispatch(stopLoading())
      }, 1200)
      return data;
    } catch (err) {
      toast.error(err?.response?.data?.error?.message);
      return rejectWithValue(err?.response?.data?.error?.message);
    }
  }
);

export const getUserBySession = createAsyncThunk(
  "user/fetchUserDetailsBySessionId",
  async ({ sessionId, role = 1 }, { rejectWithValue, dispatch }) => {
    try {
      const user = await getUserBySessionId(sessionId, role);

      return user;
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

export const getUsersBySession = createAsyncThunk(
  "user/fetchUsersDetailsBySessionId",
  async (sessionId, { rejectWithValue }) => {
    try {
      const user = await getUsersBySessionId(sessionId);
      return user;
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

export const getSessionById = createAsyncThunk(
  "session/fetchSessionDetialsById",
  async (values, { rejectWithValue }) => {
    try {
      const session = await getSessionByIdApi(values.sessionId);
      return session;
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

export const getUserById = createAsyncThunk(
  "user/fetchUserDetailsById",
  async (values, { rejectWithValue }) => {
    try {
      const user = await getUserByIdApi(values);
      return user;
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

export const updateEmotionStatus = createAsyncThunk(
  "update/emotionStatus",
  async ({ userId, status }, { rejectWithValue, getState }) => {
    try {
      const state = getState();
      if (!userId) {
        return { ...state.session.isEmotionActive, status: !state.session.isEmotionActive.status }
      } else {
        const user = await updateEmotionStatusApi(userId, status);
        return user;
      }
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);